// src/components/LandingHeader.js
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/img/logo.png';

const LandingHeader = () => {
  return (
    <header 
      className="landing-header" 
      style={{ 
        position: 'fixed', 
        top: 0, 
        width: '100%', 
        zIndex: 1000,
        background: 'rgba(0, 0, 0, 0.9)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
      }}
    >
      <nav className="navbar navbar-expand-md navbar-dark">
        <div className="container">
          <Link className="navbar-brand fw-bold d-flex align-items-center" to="/">
            <img src={logo} width="40" height="56" alt="SPONO Logo" className="me-2" />
            <span style={{ 
              fontSize: '1.5rem', 
              background: 'linear-gradient(to right, #662D8C, #ED1E79)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              fontWeight: 900,
              letterSpacing: '1px'
            }}>
              SPONO
            </span>
          </Link>
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#landingNav"
            aria-controls="landingNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="landingNav">
            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item">
                <a href="#features" className="nav-link" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  Features
                </a>
              </li>
              <li className="nav-item">
                <a href="#how-it-works" className="nav-link" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  How It Works
                </a>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  About
                </Link>
              </li>
              <li className="nav-item">
                <a href="#download" className="nav-link" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  Download
                </a>
              </li>
              <li className="nav-item ms-md-3">
                <Link 
                  to="/login" 
                  className="btn btn-sm"
                  style={{
                    background: 'linear-gradient(to right, #662D8C, #ED1E79)',
                    border: 'none',
                    color: 'white',
                    fontWeight: 600,
                    padding: '8px 20px',
                    borderRadius: '25px',
                    boxShadow: '0 4px 12px rgba(102, 45, 140, 0.3)'
                  }}
                >
                  Promoter Login
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default LandingHeader;
